import { createApp } from 'vue';
import ArcoVue from '@arco-design/web-vue';
import App from './App.vue';
import router from './router/main-routes';
import { createPinia } from 'pinia';

// 导入所有 Arco Design 的样式
import '@arco-design/web-vue/dist/arco.css';
// 导入 Message 组件的样式
import '@arco-design/web-vue/es/message/style/css.js';
// 导入图标
import '@arco-design/web-vue/es/icon/index.js';

import './main.scss';
import "@/utils/request";

const app = createApp(App);
const pinia = createPinia();

app.use(ArcoVue, {
  // 全局配置
  message: {
    duration: 5000,
    position: 'top'
  }
});

app.use(router);
app.use(pinia);

app.mount('#app');
